export function getRawLocalStorage<T>(key: string): T | null {
  const rawData = localStorage.getItem(key);

  try {
    const data = JSON.parse(rawData ?? '') as { rawData?: string; expires: number };

    if (data?.rawData !== undefined) {
      return data.rawData as T;
    }

    return null;
  } catch (error) {
    console.error(error);
    return rawData as T;
  }
}
